import { Sparkles, Loader2, ArrowRight } from "lucide-react";
import { Button } from "./ui/button";

// Step-1 primary action: render from a photo, or continue with an uploaded AI render.
export const GenerateButton = ({ fromPhoto, loading, disabled, onClick }) => {
  let content;
  if (loading) {
    content = (
      <>
        <Loader2 className="h-5 w-5 animate-spin" /> {fromPhoto ? "Rendering your duck…" : "Uploading your render…"}
      </>
    );
  } else if (fromPhoto) {
    content = (
      <>
        <Sparkles className="h-5 w-5" /> Generate Duck Figurine
      </>
    );
  } else {
    content = (
      <>
        <ArrowRight className="h-5 w-5" /> Continue with this render
      </>
    );
  }
  return (
    <Button data-testid="photo-upload-submit-btn" disabled={disabled} onClick={onClick} className="w-full h-14 rounded-full text-base font-bold gap-2 duck-shadow">
      {content}
    </Button>
  );
};
